import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-common',
  template: '<ion-router-outlet></ion-router-outlet>',
})
export class AuthCommonComponent {
  constructor() {}
}
